/**
 * Enum depicting path operation type
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.9.15
 */
export enum PathOperationTypes {
    ARC_TO = "ARC_TO",
    CLOSE = "CLOSE",
    LINE_TO = "LINE_TO",
    MOVE_TO = "MOVE_TO",
    CUBIT_BEZ_TO = "CUBIT_BEZ_TO",
    QUAD_BEZ_TO = "QUAD_BEZ_TO",
}
